import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'jobs/FETCH_REQUEST'
const FETCH_SUCCESS = 'jobs/FETCH_SUCCESS'
const FETCH_FAILURE = 'jobs/FETCH_FAILURE'
const DELETE_REQUEST = 'jobs/DELETE_REQUEST'
const DELETE_SUCCESS = 'jobs/DELETE_SUCCESS'
const DELETE_FAILURE = 'jobs/DELETE_FAILURE'
const FILTER_REQUEST = 'jobs/FILTER_REQUEST'
const FILTER_SUCCESS = 'jobs/FILTER_SUCCESS'
const FILTER_FAILURE = 'jobs/FILTER_FAILURE'

const initialState = {
  result:
    {
      new_applicant_count: 0, records: [], page: 1, total_count: 0,
      dropdown_options: {
        jobs: {
          company_descriptions: [],
          ages: [],
          ethnicities: [],
          availabilities: []
        },
        other_experiences: {
          working: [],
          geographical: []
        },
        experiences: {
          fields: [],
          qualifications: [],
          previous_experiences: []
        }
      }
    },
  loading: false,
  loaded: false,
  deleting: false,
  deleted: false,
  filtering: false,
  filtered: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FILTER_FAILURE,
    errors,
  }
}

export function filterRequest() {
  return {
    type: FILTER_REQUEST,
  }
}

export function filterSuccess(payload) {
  return {
    type: FILTER_SUCCESS,
    payload,
  }
}

export function filterFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload) {
  return {
    type: DELETE_SUCCESS,
    payload,
  }
}

export function deleteFailure(errors) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function filterData(options = {}) {
  return (dispatch) => {
    dispatch(filterRequest())

    return api(`api/v1/jobs`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(filterSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(filterFailure(errors))
        })
      })
  }
}

export function loadData(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/jobs`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function deleteJob(id) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    return api(`api/v1/jobs/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(deleteSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(deleteFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: {},
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: errors
      }
    case FILTER_REQUEST:
      return Object.assign({}, state, {
        filtering: true
      })
    case FILTER_SUCCESS:
      return Object.assign({}, state, {
        filtering: false,
        filtered: true,
        errors: {},
        result: payload
      })
    case FILTER_FAILURE:
      return {
        ...state,
        filtering: false,
        filtered: false,
        errors: errors
      }
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        deleted: true,
        errors: {},
        result: payload
      })
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        deleted: false,
        errors: errors
      }
    default:
      return state
  }
}
